import { useState, useEffect } from "react";
import useAxiosPrivate from "../../hooks/useAxiosPrivate.js";
import { Table, Pagination, Divider } from "antd";
import { useNavigate } from "react-router-dom";
import Endpoints from "../../api/endpoints.js";
import routes from "../../utils/routes.js";
import useSuccessErrorModal from "../../hooks/successErrorModal/useSuccessErrorModal.js";
import EndpointFunctions from "../../utils/Functions/endpointFunctions.js";
import { InvalidSubsColumns } from "./InvalidSubsColumns.js";
const InvalidSubs = () => {
  const { showModal, closeModal, ModalComponent } = useSuccessErrorModal();

  const [filter, setFilter] = useState({
    total: 0,
    page: 0,
    size: 10,
    pageCount: 0,
  });

  const [tableData, setTableData] = useState([]);
  const [tableLoading, setTableLoading] = useState(false);
  const axiosPrivate = useAxiosPrivate();
  const navigate = useNavigate();

  useEffect(() => {
    fetchClientData();
  }, [filter.page, filter.size]);

  const fetchClientData = async () => {
    setTableLoading(true);

    const result = await EndpointFunctions.fetchData({
      endpointURL: Endpoints.getInvalidSubscriptions,
      axiosPrivate: axiosPrivate,
      httpParams: {
        page: filter.page,
        size: filter.size,
      },
    });

    if (result.success) {
      setTableData(result?.data.data);
      setFilter((prev) => ({
        ...prev,
        total: result?.data.total,
        page: prev.page,
        size: result?.data.pageSize,
        pageCount: result?.data.pageCount,
      }));
      setTableLoading(false);
    } else {
      setTableLoading(false);
      showModal(result.errorTitle, result.errorMessage, () => {
        closeModal();
      });
    }
  };

  const paginationChange = (page, pageSize) => {
    setFilter({ ...filter, page: page - 1, size: pageSize });
  };

  const goToClientDetails = (id) => {
    navigate(`${routes.shopDetails}/${id}`);
  };

  return (
    <>
      <Table
        pagination={false}
        dataSource={tableData}
        columns={InvalidSubsColumns({ goToClientDetails })}
        scroll={{ x: true }}
        loading={tableLoading}
      />
      <div style={{ height: 20 }} />
      <div style={{ display: "flex", justifyContent: "center" }}>
        <Pagination
          onChange={paginationChange}
          total={filter.total}
          showTotal={(total, range) =>
            `${range[0]}-${range[1]} / toplam ${total} kayıt`
          }
          pageSize={filter.size}
          current={filter.page + 1}
          showSizeChanger
          pageSizeOptions={[10, 20, 50, 100]}
          onShowSizeChange={(current, size) => {
            setFilter({ ...filter, page: 0, size });
          }}
        />
      </div>
      <div style={{ height: 20 }} />
      <ModalComponent></ModalComponent>
    </>
  );
};

export default InvalidSubs;
